export const toggleValues = {
  on: 'on',
  off: 'off',
};
